import { render, staticRenderFns } from "./GBPhotoAlbumItemNotReference.vue?vue&type=template&id=61dd7724&"
import script from "./GBPhotoAlbumItemNotReference.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumItemNotReference.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumItemNotReference.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports